import { setBodyOverflow } from '../../helpers/utils.js';

export default function ({
    isSticky = false,
    hideOnMobile = false,
    isOpen = false
} = {}) {
    return {
        isOpen,
        isSticky,
        hideOnMobile,

        init() {
            this.$el.classList.remove('hidden');
            this.setupWatchers();
            const { stickySidebar } = this.$refs;

            if (stickySidebar) {
                this.createStickySidebar(stickySidebar);
            }
        },

        createStickySidebar(stickySidebar) {
            let endScroll = window.innerHeight - stickySidebar.offsetHeight;
            let startPosition = window.scrollY;
            const screenHeight = window.innerHeight;
            const topAdditionalDistance = '96px';
            const bottomAdditionalDistance = '60px';

            stickySidebar.style.top = 0;
            stickySidebar.style.position = 'sticky';

            document.addEventListener('scroll', () => {
                const stickyElementHeight = stickySidebar.offsetHeight;
                const stickyElementDistanceFromTop = parseInt(
                    stickySidebar.style.top.replace('px;', '')
                );

                endScroll = window.innerHeight - stickySidebar.offsetHeight;

                if (stickyElementHeight > screenHeight) {
                    if (window.scrollY < startPosition) {
                        if (stickyElementDistanceFromTop < 0) {
                            stickySidebar.style.top =
                                stickyElementDistanceFromTop +
                                startPosition -
                                window.scrollY +
                                'px';
                        } else if (
                            stickyElementDistanceFromTop > 0 &&
                            stickyElementDistanceFromTop !== 0
                        ) {
                            stickySidebar.style.top = topAdditionalDistance;
                        }
                    } else {
                        if (stickyElementDistanceFromTop > endScroll) {
                            stickySidebar.style.top =
                                stickyElementDistanceFromTop +
                                startPosition -
                                window.scrollY +
                                'px';
                        } else if (stickyElementDistanceFromTop < endScroll) {
                            stickySidebar.style.top = endScroll + 'px';
                        }
                        stickySidebar.style.paddingBottom =
                            bottomAdditionalDistance;
                    }
                }
                startPosition = window.scrollY;
            });
        },

        setupWatchers() {
            this.$watch('$store.mq.minWidth', () => {
                setBodyOverflow(this.isOpen);
                this.close();
            });

            this.$watch('isOpen', () => {
                setBodyOverflow(this.isOpen);
            });
        }
    };
}
